@if (component) {
<href [link]="component.cta_link">
     <img class="w-12"
          [dfImage]="component.image"
          [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
          [ratio]="component.ratio">
</href>
}